import React, { useContext } from "react";
import {
  DeleteIcon,
} from "assests/GmsIcons";
import {
  SB3RuleContext
} from "../Rules/SB3RuleContext";
import LogicRuleSubConditionComponent from "./LogicRuleSubConditionComponent";
import {LOGICAL_OPERATORS_SOURCE, LOGICAL_OPERATORS_TARGET} from "./constants";

type LogicRulePreSubConditionComponentPropType = {
  data: any;
  index: number,
  deleteMethod: (rootIndex: number, index: number) => void,
  type: string,
  rootIndex: number

};

const LogicRulePreSubConditionComponent = ({ rootIndex, index, data, deleteMethod, type }: LogicRulePreSubConditionComponentPropType) => {
  const { logicRule, updateLogicalOperator } = useContext(SB3RuleContext);

  return (

    <div className="tw-flex">
      <LogicRuleSubConditionComponent rootIndex={rootIndex}
        data={data} index={index} type={type} />
      <div className="tw-mt-8">
        <label>
          Logical Operators
        </label>
        <div className="tw-flex">
          <select value={
            type === 'source' ?
              logicRule?.rule?.source[rootIndex]?.condition[index]?.rule?.operator :
              logicRule?.rule?.target?.operator
          }
            onChange={(e) => { updateLogicalOperator(rootIndex, index, type, e.target.value) }}
            className="tw-w-[120px] tw-mt-2 tw-h-9 tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-border tw-border-zinc-200 tw-justify-start tw-items-center tw-gap-2.5 tw-inline-flex">
            {(type === 'source' ? LOGICAL_OPERATORS_SOURCE : LOGICAL_OPERATORS_TARGET).map((x, xIndex) =>
            (<option key={xIndex} value={x}>
              {x.toUpperCase().replaceAll('_', ' ')}
            </option>)
            )}
          </select>
          {type === 'source' && <button onClick={
            () => {
              deleteMethod(rootIndex, index)
            }
          } className="tw-ml-4">
            <DeleteIcon />
          </button>}
        </div>
      </div>
    </div>
  );
};

export default LogicRulePreSubConditionComponent;
